module.exports = __webpack_public_path__ + "static/media/flowImg.5c6d8fce.png";